(() => {
  const widget = document.querySelector('[data-wamory-suggestions]');
  if (!widget) return;
  const dialog = widget.querySelector('[data-suggestion-dialog]');
  const form = widget.querySelector('[data-suggestion-form]');
  const message = form.querySelector('[name="message"]');
  const honeypot = form.querySelector('[name="website"]');
  const status = widget.querySelector('[data-suggestion-status]');
  const submit = form.querySelector('button[type="submit"]');
  const formPanel = widget.querySelector('[data-suggestion-form-panel]');
  const success = widget.querySelector('[data-suggestion-success]');
  const lang = widget.dataset.lang;

  try { if (sessionStorage.getItem('wamory-suggestions-hidden') === 'true') widget.dataset.hidden = 'true'; } catch {}

  widget.querySelector('[data-suggestion-open]').addEventListener('click', () => {
    dialog.showModal();
    dialog.scrollTop = 0;
  });
  widget.querySelectorAll('[data-suggestion-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  widget.querySelector('[data-suggestion-dismiss]').addEventListener('click', () => {
    widget.dataset.hidden = 'true';
    try { sessionStorage.setItem('wamory-suggestions-hidden', 'true'); } catch {}
  });
  dialog.addEventListener('click', event => {
    if (event.target === dialog) dialog.close();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const text = message.value.trim();
    if (text.length < 4 || text.length > 2000 || !crypto.randomUUID) {
      status.textContent = lang === 'ar' ? 'اكتبي رسالة من 4 أحرف على الأقل.' : 'Please enter at least 4 characters.';
      return;
    }
    submit.disabled = true;
    status.textContent = lang === 'ar' ? 'جارٍ إرسال رسالتكِ…' : 'Sending your note…';
    try {
      const response = await fetch(widget.dataset.api, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ message: text, website: honeypot.value, id: crypto.randomUUID() }),
      });
      const result = await response.json();
      if (!response.ok || !result.ok) throw new Error(result.error || 'send-failed');
      formPanel.hidden = true;
      success.hidden = false;
      status.textContent = '';
      submit.disabled = false;
      dialog.scrollTop = 0;
      success.setAttribute('tabindex', '-1');
      success.focus({ preventScroll: true });
      form.reset();
    } catch {
      status.textContent = lang === 'ar' ? 'ما قدرنا نرسل الرسالة الآن. حاولي مرة ثانية.' : 'Your note could not be sent. Please try again.';
      submit.disabled = false;
    }
  });
})();
